export * from './slider.component.jsx';


// WEBPACK FOOTER //
// ./src/components/slider/index.js